// extracted by mini-css-extract-plugin
export default {"markWrapper":"OfferMark_markWrapper","blockInfo":"OfferMark_blockInfo","clockTime":"OfferMark_clockTime","timerWrapper":"OfferMark_timerWrapper"};